module.exports = __webpack_public_path__ + "static/media/undraw_completed_ngx6.f641ac38.png";